export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-10T15:36:53",
  lastPipeline: "6520",
  version: "0.0.0",
  sentryDsn: '',
};
